import {blockPagesEpics} from './BlockPages/blockPagesEpics'
import {generalEpics} from './General/generalEpics'
import {userEpics} from './Users/userEpics'
import {endpointsEpics} from './Endpoints/endpointsEpics'

export const settingsEpics = [
  ...userEpics,
  ...generalEpics,
  ...blockPagesEpics,
  ...endpointsEpics,
]
